import { W as WuiList$1, d as defineCustomElement$1 } from './list.js';

const WuiList = WuiList$1;
const defineCustomElement = defineCustomElement$1;

export { WuiList, defineCustomElement };

//# sourceMappingURL=wui-list.js.map